/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../graphql/generated/types';

import { gql } from '@apollo/client';
export type HcoCoreFragment = {
	__typename?: 'HCO';
	vid_V: string;
	veevaid_V: string;
	statusCda_V?: string | null;
	statusCda_VId?: string | null;
	hcoNameCda_V?: string | null;
	hcoNameShort_V?: string | null;
	hcoNameEnglish_V?: string | null;
	hcoNameIntl_V?: string | null;
	hcoTypeCda_V?: string | null;
	hcoType?: { __typename?: 'HCOType'; id: string; name: string } | null;
};

export const HcoCoreFragmentDoc = gql`
	fragment HCOCore on HCO {
		vid_V
		veevaid_V
		statusCda_V
		statusCda_VId
		hcoNameCda_V
		hcoNameShort_V
		hcoNameEnglish_V
		hcoNameIntl_V
		hcoTypeCda_V
		hcoType {
			id
			name
		}
	}
`;
